import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOData {
  title: string;
  description: string;
  keywords: string;
  ogImage?: string;
}

const seoData: Record<string, SEOData> = {
  '/': {
    title: 'Aifinity - AI-utveckling & 3D-produktion i framkant',
    description: 'Empowering Innovation: AI-utveckling & 3D-produktion i framkant. Professionella AI-lösningar, 3D-printning och teknisk innovation för moderna företag.',
    keywords: 'AI Utveckling Stockholm, 3D Printing Sverige, Generativ AI B2B, AI-konsultation, 3D-produktion, AI-agenter, Klagobot',
    ogImage: '/aifinity_logo_banner.png'
  },
  '/artists': {
    title: 'Aifinity Music - AiMusicdreams & iDreamz',
    description: 'Upptäck framtidens musik med våra AI-artister. Lyssna på senaste låtarna, köp merch och följ oss på sociala medier.',
    keywords: 'AiMusicdreams, iDreamz, AI Music, Musiknyheter, Merch, Spotify, Electronic Music',
    ogImage: '/AIMusicDreams-trasparent.png'
  }
};

export const SEOHead = () => {
  const location = useLocation();
  const currentSEO = seoData[location.pathname] || seoData['/'];

  useEffect(() => {
    // Update document title
    document.title = currentSEO.title;

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', currentSEO.description);

    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', currentSEO.keywords);

    // Update OG tags
    const updateOGTag = (property: string, content: string) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    updateOGTag('og:title', currentSEO.title);
    updateOGTag('og:description', currentSEO.description);
    if (currentSEO.ogImage) {
      updateOGTag('og:image', `${window.location.origin}${currentSEO.ogImage}`);
    }
  }, [location.pathname, currentSEO]);

  // Structured Data (JSON-LD)
  useEffect(() => {
    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Aifinity',
      url: 'https://aifinity.se',
      logo: `${window.location.origin}/aifinity_logo_banner.png`,
      description: currentSEO.description,
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'info@aifinity.se'
      },
      sameAs: [
        'https://www.linkedin.com/company/aifinity'
      ]
    };

    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(organizationSchema);
    document.head.appendChild(script);
  }, [currentSEO.description]);

  return null;
};

